import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Ordre section / alphabétique
import { EncryptStorage } from 'encrypt-storage';
import routes from './modules/routes';

// Compte
import activiteJeux from './modules/activiteJeux';
import aide from './modules/aide';
import bingo from './modules/bingo';
import casinoPrivileges from './modules/casinoPrivileges';
import compte from './modules/compte';
import consentement from './modules/consentement';
import encadrerJeux from './modules/encadrerJeux';
import depot from './modules/depot';
import menu from './modules/menu';
import message from './modules/message';
import navigation from './modules/navigation';
import profile from './modules/profile';
import profileComplet from './modules/profileComplet';
import preferences from './modules/preferences';
import promo from './modules/promo';
import dossier from './modules/dossier';

// Casino
import etiquette from './modules/etiquette';
import integrateur from './modules/integrateur';
import fournisseur from './modules/fournisseur';
import produitCasino from './modules/produitCasino';
import produitCollection from './modules/produitCollection';
import progressif from './modules/progressif';

// CED
import cedFamille from './modules/cedFamille';
import cedPresentateur from './modules/cedPresentateur';
import cedTable from './modules/cedTable';

Vue.use(Vuex);

// idle-vue rend disponible state.idleVue à ce niveau

const debug = process.env.NODE_ENV !== 'production';

export const encryptStorage = new EncryptStorage(process.env.VUE_APP_STORE_KEY, {
  prefix: '@ce',
  storageType: 'sessionStorage',
  stateManagementUse: true,
});

const interceptorMutation = function mutationInterceptorPlugin() {
  return (store) => {
    store.subscribe((mutation, playload) => {
      if (
        mutation.type.match(/^(compte|promo|profile|dossier)\//i) &&
        !mutation.type.match(/\/SET_LASTUPDATE/i)
      ) {
        const key = `${mutation.type.split(/(compte|promo|profile|dossier)/)[1]}/setLastUpdate`;
        // IMPORTANT: dispatch car souvent appellé et génère des erreurs du type Max Call Stack Exceeded
        store.dispatch(key, Date.now());
      }
    });
  };
};

export default new Vuex.Store({
  modules: {
    routes,

    // Ordre section / alphabétique
    // Compte
    activiteJeux,
    aide,
    bingo,
    casinoPrivileges,
    compte,
    consentement,
    encadrerJeux,
    depot,
    menu,
    message,
    navigation,
    profile,
    profileComplet,
    preferences,
    promo,
    dossier,

    // Casino
    etiquette,
    fournisseur,
    integrateur,
    produitCasino,
    produitCollection,
    progressif,

    // CED
    cedFamille,
    cedPresentateur,
    cedTable,
  },
  plugins: [
    interceptorMutation(),
    createPersistedState({
      key: 'compte',
      paths: ['compte', 'profile', 'promo'],
      storage: {
        getItem: (key) => encryptStorage.getItem(key),
        setItem: (key, value) => encryptStorage.setItem(key, value),
        removeItem: (key) => encryptStorage.removeItem(key),
      },
    }),
    // TODO: persister les produits -> ajouter "indRetire"? régler l'auto refresh
    // createPersistedState({
    //   key: "casino",
    //   paths: ["produitCasino"],
    //   // localStorage par défaut
    // }),
  ],
  strict: debug,
});
